export const PROFILE = 'PROFILE';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const PRIMARY_COMPANY_ID = 'PRIMARY_COMPANY_ID';
